import {setCookie, getCookie, removeCookie} from 'common/util/cookie';
import {setFlag, incrementFlag} from 'common/report/queries/legacy-django-api/user-flags';
import {isStandalone} from 'common/report/util';
import {trackReportLoadPerf, getPageLoadPerfProps} from 'common/report/perf-measure';
import {stat} from 'common/report/util/stat';
import {debounce, mixin, each, isUndefined, get, set, isEmpty, includes} from 'lodash';

_.noConflict(); // don't export lodash as window global

// django templates access mp.cookie, mp.utility and _ as globals
// export them in window only if non-standalone (django mode)
if (!isStandalone()) {
  const utility = (mp.utility = mp.utility || {});
  Object.assign(utility, {
    get_page_load_perf_props: getPageLoadPerfProps,
    increment_flag: incrementFlag,
    set_flag: setFlag,
    stats: {stat},
    track_report_load_perf: trackReportLoadPerf,
  });

  mp.cookie = {
    set: setCookie,
    get: getCookie,
    remove: removeCookie,
  };

  // django template uses underscore but we export equivalent lodash functions if _ not present
  if (!window[`_`]) {
    const lodash = (window[`_`] = {
      debounce,
      each,
      isUndefined,
      isEmpty,
      includes,
      contains: includes,
    });

    mixin(
      lodash,
      {
        namespace(obj, path) {
          if (isUndefined(path)) {
            path = obj;
            obj = this;
          }

          const value = get(obj, path, {});
          obj = set(obj, path, value);
          return value;
        },
      },
      {chain: false},
    );
  }
}
